import { constantAPI, Constants } from './redux/types';

export const ConvertConstants = (data: constantAPI) => {
    let constants: Constants = {
        idTypes: [],
        individualAccreditation: [],
        institutionalAccreditation: [],
        nationalities: [],
        residentialStatus: [],
        countries: [],
    };
    data.idTypes?.forEach((i) => {
        constants.idTypes.push({
            label: i,
            value: i,
        });
    });
    constants.individualAccreditation = data.individualAccreditation;
    constants.institutionalAccreditation = data.institutionalAccreditation;
    data.nationalities?.forEach((n) => {
        constants.nationalities.push({
            label: n,
            value: n,
        });
    });
    data.residentialStatus?.forEach((r) => {
        constants.residentialStatus.push({
            label: r,
            value: r,
        });
    });

    constants.countries = data.countries;

    return constants;
};
